import React from 'react'
import moment from "moment";
import {WsChatMessage} from "../../../../types/message";

type MessageItemProps = {
  message?: WsChatMessage
}

export const MessageItem = React.memo(({message}: MessageItemProps) => {
  const isSend = message?.is_admin

  return (
      <div>
        {message?.sender?.id && (isSend ? <div className="d-flex d-flex justify-content-end mb-5">
              <div className="d-flex flex-column align-items align-items-end">
                <div className="d-flex align-items-center mb-2 gap-2">
                  <a
                      className="fs-5 fw-bolder text-gray-900 text-hover-primary ms-1">{message?.sender?.first_name} {message?.sender?.last_name}</a>
                </div>
                <div className="p-5 rounded bg-light-primary text-gray-900 fw-bold mw-lg-400px"
                     data-kt-element="message-text">
                  {message?.message && <p className={`mb-0`}>
                    {message?.message}
                  </p>}
                </div>
                <div className=""><span
                    className="text-muted fs-7 my-2 d-block">{moment(message?.created_at).format("DD.MM.YYYY HH:mm")}</span>
                </div>
              </div>
            </div> :
            <div className={`d-flex justify-content-start mb-5`}>
              <div className={`d-flex flex-column align-items align-items-start`}>
                <div className="d-flex align-items-center mb-2">
                  <div className="ms-3"><span
                      className="fs-5 fw-bolder text-gray-900 text-hover-primary me-1">{message?.sender?.first_name} {message?.sender?.last_name}</span>
                  </div>
                </div>
                <div className="p-5 rounded bg-light-info text-gray-900 fw-bold mw-lg-400px">
                  {message?.message && <p className={`mb-0`}>
                    {message?.message}
                  </p>}
                </div>
                <span
                    className="text-muted fs-7 my-2 d-block">{moment(message?.created_at).format("DD.MM.YYYY HH:mm")}</span>
              </div>
            </div>)}
      </div>
  )
})
